
// achievements-card mobile slider start

if ($(Window).width() < 1023) {
    $('.investor-rewards__items').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true
    });

    $('.achievements__items').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true
    });
}
$('.achievements__arrow-left').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});
$('.achievements__arrow-right').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickNext');
});

// achievements-card mobile slider end



// investor-rewards mobile slider start
$('.investor-rewards__arrow-left').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});
$('.investor-rewards__arrow-right').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickNext');
});

// investor-rewards mobile slider end




const videoWrapper = document.querySelector('.video-section__video');
const video = videoWrapper.querySelector('video');
const playIcon = videoWrapper.querySelector('.video-section__play-icon');
videoWrapper.addEventListener('click', function () {
    if (video.paused) {
        video.play();
        playIcon.style.display = 'none';
    } else {
        video.pause();
        playIcon.style.display = 'flex';
    }
});




// $(".accordion").addClass("active");
$(".accordion").on("click", function () {
    if ($(this).hasClass("active")) {
        $(this).removeClass("active");
        $(this).find(".accordion__content")
            .stop(true, true)
            .slideUp(300);
    } else {
        $(this).addClass("active");
        $(this).find(".accordion__content")
            .stop(true, true)
            .slideDown(300);
    }
});

